import i18n from '@/locales/i18n';
import { resolveHintAnchor, showAnchorHint } from '@/composables/useAnchorHint';

const CREATE_MARKET_SOON_MS = 2200;

function resolveAnchorFromEvent(event) {
  const current = event?.currentTarget;
  if (current instanceof HTMLElement) return current;
  const target = event?.target;
  if (target instanceof Element) {
    const button = target.closest('button, a, [role="button"]');
    if (button instanceof HTMLElement) return button;
  }
  return null;
}

/**
 * 创建市场入口暂未开放：在点击锚点旁提示「即将推出」。
 * @param {Event|HTMLElement|null|undefined} anchorOrEvent
 */
export function promptCreateMarketComingSoon(anchorOrEvent) {
  const raw =
    anchorOrEvent instanceof HTMLElement
      ? anchorOrEvent
      : resolveAnchorFromEvent(anchorOrEvent);
  const el = resolveHintAnchor(raw);
  if (!el) return;
  const text = String(i18n.global.t('nav.createMarketComingSoon') ?? '').trim();
  if (!text) return;
  showAnchorHint({ anchor: el, text, duration: CREATE_MARKET_SOON_MS });
}
